import FleetTitle from '@/libs/antd/components/Title';
import { Button, Form, Table } from 'antd';
import { FC, Fragment } from 'react';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import TextArea from 'antd/es/input/TextArea';
import rule from '@/libs/antd/rules';
import { useMutation } from '@tanstack/react-query';
import { submitCCAVisitReportApproval } from '@/libs/fleet-api/services/visit-reports';
import { useApp } from '@/App';
import { useCCAVisitReportVerificationPage } from './VisitReportVerificationPage';

const CCAVisitReportApprovalForm: FC = () => {
	const { notification, navigate } = useApp();
	const { approval, surveyInformation } = useCCAVisitReportVerificationPage();
	const { approvalHistories } = approval;

	const submitCCAVisitReportApprovalMutation = useMutation({
		mutationFn: submitCCAVisitReportApproval,
	});

	return (
		<Fragment>
			<FleetTitle>Approval History</FleetTitle>
			<Table
				dataSource={
					approvalHistories?.map((record, key) => {
						return { ...record, key };
					}) ?? []
				}
				columns={[
					{
						title: 'No',
						width: 1,
						align: 'center',
						dataIndex: 'no',
					},
					{
						title: 'Name',
						dataIndex: 'approvalBy',
					},
					{
						title: 'Date',
						dataIndex: 'approvalDate',
					},
					{
						title: 'Process',
						dataIndex: 'approvalProcess',
					},
					{
						title: 'Status',
						align: 'center',
						render: (_, record) => {
							return (
								<span
									className={`review-status ${record.approvalStatus.toLowerCase()}`}
								>
									{record.approvalStatus}
								</span>
							);
						},
					},
					{
						title: 'Approval Notes',
						dataIndex: 'approvalNote',
					},
				]}
				bordered
				pagination={false}
				style={{ marginBottom: 20 }}
			/>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				onFinish={async (values) => {
					try {
						await submitCCAVisitReportApprovalMutation.mutateAsync({
							notes: (values as { notes: string }).notes,
							surveyId: String(surveyInformation.id),
						});
						notification.success({
							message: 'Success',
							description: 'Submit approval success',
						});
						navigate('CCAVisitReportListPage');
					} catch {
						notification.error({
							message: 'Failed',
							description: 'Submit approval failed',
						});
					}
				}}
			>
				<Form.Item
					name="notes"
					label="Approval Notes"
					labelCol={{ span: 6 }}
					wrapperCol={{
						style: {
							color: 'blue',
							marginLeft: -10,
						},
					}}
					rules={[rule.required()]}
				>
					<TextArea rows={3} />
				</Form.Item>
				<Button
					type="primary"
					htmlType="submit"
					style={{
						width: 200,
						display: 'block',
						marginLeft: 'auto',
						marginTop: 20,
					}}
					loading={submitCCAVisitReportApprovalMutation.isPending}
				>
					SAVE
				</Button>
			</Form>
		</Fragment>
	);
};

export default CCAVisitReportApprovalForm;
